import React from 'react';
import { ChefHat } from 'lucide-react';

const DashboardPage = ({ user }) => {
  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 text-center">
        <ChefHat className="w-16 h-16 text-orange-500 mx-auto mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Welcome, {user?.full_name || user?.username}!
        </h2>
        <p className="text-gray-500 dark:text-gray-400">
          Recipe Genie Admin Dashboard — coming soon.
        </p>
      </div>
    </div>
  );
};

export default DashboardPage;
